import { useEffect, useState } from "react"

export function useDimensions() {
    const [windowDimensions, setWindowDimensions] = useState<{ width: number; height: number }>({
        width: window.innerWidth,
        height: window.innerHeight,
    })

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window
        return {
            width,
            height,
        }
    }

    useEffect(() => {
        let timer: any = null
        function handleResize() {
            clearTimeout(timer)
            timer = setTimeout(() => setWindowDimensions(getWindowDimensions()), 150)
        }

        window.addEventListener("resize", handleResize)
        return () => {
            clearTimeout(timer)
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    return windowDimensions
}
